import _ from 'lodash'
import Backbone from 'backbone'

/**
 * A Key Set for a particular dataset tree
 *
 * @property {Number} id The key set id
 *
 * @property {String} attributes.label The key set label
 *
 * @property {String[]} attributes.keys The string values of each key
 * derived from 'datasettreekeys.keystr'
 *
 * @property {Number} attributes.datasetTree.id
 *
 */
var KeySet = Backbone.Model.extend({

	// this.datasetTree should be initialized to the dataset tree this key set belongs to

	urlRoot: function() {
		return 'api/dataset-trees/' + this.get('datasetTree').id + '/key-sets'
	},

	comparator: function(model) {
		return model.get('label').toUpperCase()
	}


})

export default KeySet

KeySet.__filename__ = 'admin/datasets/key-set.js'
